import { useEffect, useRef } from 'react';

import { usePostOfficeExernalMessageProxy } from '@atlassian/post-office-context/post-office-trigger';

import { SPOTLIGHT_MESSAGE_ID } from '../../common/constants/spotlight';
import { useSpotlightState } from '../../controllers/store/spotlight';

export const useSpotlightPrefetch = (): void => {
	const [spotlight, { start }] = useSpotlightState();
	const hasRequestedMessageRef = useRef(false);
	const { requestMessageStart, dismissMessage, hasMessageStarted } =
		usePostOfficeExernalMessageProxy(SPOTLIGHT_MESSAGE_ID);

	useEffect(() => {
		if (!hasRequestedMessageRef.current) {
			requestMessageStart();
			hasRequestedMessageRef.current = true;
			return;
		}

		// If spotlight should be shown within Post Office logic
		if (hasMessageStarted) {
			start();
		}
	}, [hasMessageStarted, requestMessageStart, start]);

	useEffect(() => {
		if (spotlight.state === 'dismiss') {
			dismissMessage();
		}
	}, [dismissMessage, spotlight.state]);
};

export const SpotlightPrefetch = () => {
	useSpotlightPrefetch();
	return null;
};
